import {DomainEvent} from './DomainEvent';
import {MatchPlaylist} from '../resources/MatchPlaylist';

export class MatchPlaylistUpdated extends DomainEvent<MatchPlaylist> {}
